module.exports = __webpack_public_path__ + "static/media/shoushanicon.eaa69758.webp";